import styled from 'styled-components';

import { brandColors } from '../../../constants/colors';

const { SUBZERO_HEX, WOLF_HEX } = brandColors;

type SwiperContainerProps = {
  shouldDisplayNavigation?: boolean;
  paginationColor: typeof SUBZERO_HEX | typeof WOLF_HEX;
};

export const SwiperContainer = styled.div.attrs({
  className: 'relative w-2/3 mx-auto'
})<SwiperContainerProps>`
  .swiper-button-next::after,
  .swiper-button-prev::after {
    display: ${({ shouldDisplayNavigation }) =>
      shouldDisplayNavigation ? 'flex' : 'none'};
    color: ${({ paginationColor }) => paginationColor};
    font-size: 20px;
    position: absolute;
  }

  .swiper-pagination {
    position: absolute;
    bottom: -30px !important;
    left: 50%;
    transform: translateX(-50%);
    font-size: 10px;
  }

  .swiper-pagination-bullet {
    cursor: pointer;
    margin: 5px;
    padding: 0px 12px 0px 0px;
    border-radius: 50%;
    background-color: #e7ebe1;
  }

  .swiper-pagination-bullet-active {
    background-color: ${(props) => props.paginationColor};
  }
`;
